import {
  SET_ISSUE_UI_FLAG,
  CLEAR_ISSUES,
  SET_ISSUES,
  SET_ISSUE_ITEM,
  EDIT_ISSUE,
  DELETE_ISSUE,
} from './types';

export const mutations = {
  [SET_ISSUE_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [CLEAR_ISSUES]: $state => {
    $state.records = {};
  },

  [SET_ISSUES]: ($state, data) => {
    const updatedRecords = { ...$state.records };
    data.forEach(issue => {
      updatedRecords[issue.id] = {
        ...(updatedRecords[issue.id] || {}),
        ...issue,
      };
    });
    $state.records = updatedRecords;
  },

  [SET_ISSUE_ITEM]: ($state, data) => {
    $state.records = {
      ...$state.records,
      [data.id]: {
        ...($state.records[data.id] || {}),
        ...data,
      },
    };
  },

  [EDIT_ISSUE]: ($state, data) => {
    $state.records = {
      ...$state.records,
      [data.id]: data,
    };
  },

  [DELETE_ISSUE]: ($state, issueId) => {
    const { [issueId]: toDelete, ...records } = $state.records;
    $state.records = records;
  },
};
